import 'vue-tsx-support/enable-check';
import Vue from 'vue';
import '../common/directive';
import { router } from './router';
import StoreContainer from './store/di';
import { App } from './pages/App';
import './style/reset';
import './style/common';
import { initReporter } from '../common/reporter';
// 初始化大同上报
initReporter();
window.Vue = Vue;
new Vue({
    el: '#app_root',
    router,
    provide: new StoreContainer(),
    render(h) {
        return h(App);
    },
});
